import { MetricCard } from '@/components/shared/MetricCard';
import { GraduationCap, Users, Video, CheckCircle, Clock, XCircle, Star, MessageSquare } from 'lucide-react';
import type { AcademyStats } from '../types';

interface AcademyStatsPanelProps {
    stats: AcademyStats | undefined;
}

export function AcademyStatsPanel({ stats }: AcademyStatsPanelProps) {
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <MetricCard
                title="Total Creadores"
                value={stats?.total_creators ?? 0}
                icon={<Users size={18} />}
                iconColor="text-primary"
            />
            <MetricCard
                title="Creadores Aprobados"
                value={stats?.creators_approved ?? 0}
                icon={<CheckCircle size={18} />}
                iconColor="text-emerald-400"
            />
            <MetricCard
                title="Creadores Pendientes"
                value={stats?.creators_pending ?? 0}
                icon={<Clock size={18} />}
                iconColor="text-amber-400"
            />
            <MetricCard
                title="Total Vídeos"
                value={stats?.total_videos ?? 0}
                icon={<Video size={18} />}
                iconColor="text-blue-400"
            />
            <MetricCard
                title="Vídeos Aprobados"
                value={stats?.videos_approved ?? 0}
                icon={<CheckCircle size={18} />}
                iconColor="text-emerald-400"
            />
            <MetricCard
                title="Vídeos Pendientes"
                value={stats?.videos_pending ?? 0}
                icon={<Clock size={18} />}
                iconColor="text-amber-400"
            />
            <MetricCard
                title="Valoraciones"
                value={stats?.total_ratings ?? 0}
                icon={<Star size={18} />}
                iconColor="text-yellow-400"
            />
            <MetricCard
                title="Valoración Media"
                value={stats?.avg_rating ? `${stats.avg_rating} ★` : '—'}
                format="none"
                icon={<Star size={18} />}
                iconColor="text-yellow-400"
            />
        </div>
    );
}
